module.exports = __webpack_public_path__ + "img/hand.0f2877c7.png";